import { directusApi } from '@/api';
import { Data } from '@/models/data.model';
import { asyncForEach, formatNested, validateFileName } from '@/utils';
import lodash from 'lodash';
import { VueTreeList, Tree, TreeNode } from 'vue-tree-list';
export interface BannerHome {
    id?: number;
    name: string;
    image?: any;
    cover_title: string;
    cover_subtitle: string;
    cover_content: string;
}

export interface BannerHomeState {
    allBannerHomes: Array<BannerHome>;
    allBannerHomesLoading: boolean;

    activeBannerHome: BannerHome | null;
    activeBannerHomeLoading: boolean;
}

const state: BannerHomeState = {
    allBannerHomes: [],
    allBannerHomesLoading: false,

    activeBannerHome: {
        id: 0,
        name: '',
        image: [],
        cover_title: '',
        cover_subtitle: '',
        cover_content: '',
    },
    activeBannerHomeLoading: false,
};

const defaultBannerHome = {
    id: 0,
    name: '',
    image: null,
    cover_title: '',
    cover_subtitle: '',
    cover_content: '',
};

const mutations = {
    TOGGLE_ALL_BANNERS_LOADING(state: BannerHomeState, data: boolean) {
        state.allBannerHomesLoading = data;
    },
    TOGGLE_ACTIVE_BANNER_HOME_LOADING(state: BannerHomeState, data: boolean) {
        state.activeBannerHomeLoading = data;
    },
    REMOVE_BANNER_HOME(state: BannerHomeState, id: number) {
        state.allBannerHomes = lodash.remove(state.allBannerHomes, function(n) {
            return n.id != id;
        });
    },
    SET_ACTIVE_BANNER_HOME(state: BannerHomeState, data: BannerHome) {
        let image = data.image ? { id: data.image, url: `https://directus.prodelec.app/assets/${data.image}`, origin: 'directus' } : null;

        state.activeBannerHome = {
            ...data,
            image,
        };
    },
};

const actions = {
    async getAll({ _, commit }: any, data: Data | null) {
        let params = '';
        if (data) params += `&search=${data.search}`;
        params += '&limit=200&meta=total_count&sort=name';
        commit('TOGGLE_ALL_BANNERS_LOADING', true);
        await directusApi('GET', `items/banners_home_ecommerce?${params}`);
    },

    async getLastOne({ _, commit }: any, data: any) {
        commit('TOGGLE_ACTIVE_BANNER_HOME_LOADING', true);
        await directusApi('GET', 'items/banners_home_ecommerce?limit=1&sort=-id')
            .then(res => {
                commit('SET_ACTIVE_BANNER_HOME', res.data.data[0]);
                console.log(res.data.data[0].id);
            })
            .catch(err => {
                console.log('El error es ' + err);
            })
            .finally(() => {
                commit('TOGGLE_ACTIVE_BANNER_HOME_LOADING', false);
            });
    },

    async getOne({ _, commit }: any, id: any | null = null) {
        commit('TOGGLE_ACTIVE_BANNER_HOME_LOADING', true);
        if (id) {
            await directusApi('GET', `items/banners_home_ecommerce/${id}`)
                .then(res => {
                    // console.log('banners ==> ', res.data.data);
                    commit('SET_ACTIVE_BANNER_HOME', res.data.data);
                })
                .catch(err => {
                    console.log(err);
                })
                .finally(() => {
                    commit('TOGGLE_ACTIVE_BANNER_HOME_LOADING', false);
                });
        } else {
            commit('SET_ACTIVE_BANNER_HOME', defaultBannerHome);
            commit('TOGGLE_ACTIVE_BANNER_HOME_LOADING', false);
        }
    },
    
    async postOne({ _, commit, dispatch }: any, data: any) {
        commit('TOGGLE_ACTIVE_BANNER_HOME_LOADING', true);

        let bannerEndpoint: string = 'items/banners_home_ecommerce';
        let bannerMethod: any = 'POST';

        if (data.data.id != 0) {
            bannerMethod = 'PATCH';
            bannerEndpoint = `items/banners_home_ecommerce/${data.data.id}`;
        }

        await directusApi(bannerMethod, bannerEndpoint, {
            name: data.data.name,
            cover_title: data.data.cover_title,
            cover_subtitle: data.data.cover_subtitle,
            cover_content: data.data.cover_content,
        })
            .then(async (banner: any) => {
                let image: any = {};
                data.data.image == '' ? (image = null) : (image = banner.data.data.image);

                // ****** START img file process
                try {
                    if (data.data.image.origin == 'upload') {
                        console.log('funcion');

                        let imageNameValidation = await validateFileName(data.data.image.name);
                        console.log(imageNameValidation);

                        if (imageNameValidation == 0) {
                            console.log('uploading', data.data.image);
                            await directusApi('POST', `files`, data.data.image.file)
                                .then(async (resFile: any) => {
                                    image = {
                                        id: resFile.data.data.id,
                                        sort: data.data.image.sort,
                                        url: `https://directus.prodelec.app/assets/${resFile.data.data.id}`,
                                        origin: 'directus',
                                        name: resFile.data.data.title,
                                        file: data.data.image.file,
                                    };
                                })
                                .catch(err => {
                                    console.log(err);
                                });
                        } else {
                            data.vm.$bvToast.toast(`Error al guardar, la imagen ${data.data.image.name} ya existe. Es necesario cambiar el nombre de la imagen desde tu computadora y volver a intentarlo`, {
                                title: `Imagen ya existente`,
                                variant: 'warning',
                                toaster: 'b-toaster-top-center',
                                autoHideDelay: 5000,
                            });
                            commit('TOGGLE_ACTIVE_BANNER_HOME_LOADING', false);
                            return false;
                        }
                    } 
                } catch (error) {
                    console.log('error => no contiene una imagen');
                }
                // ****** END img file process

                // ********************** START adding id of img to banner
                console.log(image);

                if (image) {
                    console.log(banner.data.data);
                    await directusApi('PATCH', `items/banners_home_ecommerce/${banner.data.data.id }`, { image: image.id, cover_title: banner.data.data.cover_title, cover_content: banner.data.data.cover_content })
                        .then(async (res: any) => {
                            console.log('image added/updated', res.data.data.image);
                            dispatch('getOne', banner.data.data.id);
                            data.vm.$bvToast.toast('Información agregada/actualizada exitosamente', {
                                title: `Obteniendo información`,
                                variant: 'success',
                                toaster: 'b-toaster-top-center',
                                autoHideDelay: 5000,
                            });
                        })
                        .catch(err => {
                            console.log('ml' + data.data.id);
                            console.log(err);
                        });
                }
                dispatch('getOne', banner.data.data.id);
                commit('TOGGLE_ACTIVE_BANNER_HOME_LOADING', false);
                dispatch('getAll');
                commit('SET_ACTIVE_BANNER_HOME', banner.data.data);
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                commit('TOGGLE_ACTIVE_BANNER_HOME_LOADING', false);
            });
    },

};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
